import { Component, OnInit } from '@angular/core';
import { TransformerManagerService } from '../services/transformerManager.service';
import { DeviceMasterService } from '../services/device-master.service';
import { EmsdashboardService } from '../services/emsdashboard.service';
@Component({
  selector: 'app-emstree',
  templateUrl: './emstree.component.html',
  styleUrls: ['./emstree.component.scss']
})
export class EmstreeComponent implements OnInit {
  matername;
  alert_count;
  Deviceid;
  uniqueDeviceId;
  currentUserData = JSON.parse(localStorage.getItem('userData'));
  energyMeterIdArray;
  arr1: any = [];
  dataTooltip;
  hoverData = [];
  allmetersid: any;
  metermanagerdata: any;
  constructor(private deviceManagerSer: DeviceMasterService, private transMngSer: TransformerManagerService, private EmsdashboardService: EmsdashboardService) { }
  ngOnInit() {
    this.getDeiceIds();
    this.getEnergymetrId();
  }
  getEnergymetrId() {
    let user_id = this.currentUserData.userid;
    let roleid = this.currentUserData.roleid;
    this.EmsdashboardService.getEnergyMeterIds({ "userid": user_id, "roleid": roleid }).subscribe(async (response: any) => {
      console.log("all id's", response);
      this.metermanagerdata = response.data;
      this.allmetersid = await response.data.map((meter: any) => meter.meterSerialNumber);
      this.getmetername();
    });
  }
  getAlertCount(meterCount) {
    console.log("response of alert", meterCount)
    this.EmsdashboardService.gethoverdatatree({ "meterid": this.allmetersid, "meterCount": meterCount }).toPromise().then((response: any) => {
      this.hoverData = response.result;
    });
  }
  getAlertDataOnHover(energyMeterIdArray) {
    let l1 = 0;
    let l2 = 0;
    let l3 = 0;
    let pf: any = 0;
    let kwh = 0;
    let l_kwh = 0;
    this.hoverData.forEach(function (lastData) {
      if (lastData.energyMeterId == energyMeterIdArray.meterid) {
        l1 = lastData.L1;
        l2 = lastData.L2;
        l3 = lastData.L3;
        pf = Number(lastData.pf).toFixed(2);
        kwh = lastData.kwh;
        l_kwh = lastData.latestkwh;
      }
    })
    let tooltipText = `Meter Name : ${energyMeterIdArray.meterName}\n`;
    this.alert_count = 0;
    tooltipText += `Alerts : ${energyMeterIdArray.alert}\n`;
    tooltipText += `parameterName : ${energyMeterIdArray.parameterName}\n`;
    tooltipText += `Metrid : ${energyMeterIdArray.meterid}\n`;
    tooltipText += `L1 : ${l1}\n`;
    tooltipText += `L2 : ${l2}\n`;
    tooltipText += `L3 : ${l3}\n`;
    tooltipText += `PF : ${pf}\n`;
    tooltipText += `KWH : ${kwh}\n`;
    tooltipText += `Latest KWH : ${l_kwh}\n`;
    this.dataTooltip = tooltipText;
  }
  getDeiceIds() {
    this.deviceManagerSer.getEMSDeviceId(JSON.parse(localStorage.getItem('userData')).userid).subscribe((response: any) => {
      if (response.result.length > 0) {
        let Deviceids = []
        response.result.forEach(function (value) {
          Deviceids.push(value.deviceId + "(" + value.sitename + ")");
        });
        this.Deviceid = Deviceids[0]
        this.uniqueDeviceId = Deviceids;
      }
    });
  }
  getmetername() {
    this.EmsdashboardService.getAlertData({ "meterid": this.allmetersid }).toPromise().then((response: any) => {
      let secondarray = response.result
      console.log("second array", secondarray);
      console.log("first array", this.metermanagerdata);
      let mergearray = [];
      secondarray.forEach(secondItem => {
        const firstItem = this.metermanagerdata.find(item => item.meterSerialNumber === secondItem.meterSerialNumber);
        if (firstItem) {
          mergearray.push({
            ...firstItem,
            ...secondItem
          });
        }
      });
      console.log("Merged Array", mergearray);
      let floorMap = new Map();
      mergearray.forEach(function (value) {
        let floorName = value.meterDescription;
        let meterName = value.assetName;
        let meterno = value.meterSerialNumber;
        let alert = value.alertCount;
        let thisdevice = value.deviceId;
        let parameters = value.parameterNames;
        if (floorMap.has(floorName)) {
          let floorArray = floorMap.get(floorName);
          floorArray.push({ floor: floorName, meterName: meterName, alert: alert, parameterName: parameters, meterid: meterno, device: thisdevice });
        } else {
          let floorArray = [{ floor: floorName, meterName: meterName, alert: alert, parameterName: parameters, meterid: meterno, device: thisdevice }];
          floorMap.set(floorName, floorArray);
        }
      });
      this.energyMeterIdArray = Array.from(floorMap.values());
      console.log("This array : energyMeterIdArray", this.energyMeterIdArray)
      this.getAlertCount(this.allmetersid.length);
    });
  }
}
function getSanitizedTooltip() {
  throw new Error('Function not implemented.');
}